import { IntlShape } from 'react-intl';
import * as yup from 'yup';

export const validateClientSecret = (input: string) => input != null && input.length >= 16;

export const createWebhookFormSchema = (intl: IntlShape) =>
  yup.object({
    clientSecret: yup
      .string()
      .test(
        'minLength',
        intl.formatMessage({ id: 'merchant-integrations.order-api.webhook.client-secret-min-len' }, { value: 16 }),
        validateClientSecret,
      )
      .required(intl.formatMessage({ id: 'merchant-integrations.order-api.webhook.client-secret-req' })),
    webhookUrl: yup
      .string()
      .url(intl.formatMessage({ id: 'merchant-integrations.order-api.webhook.url-valid' }))
      .required(intl.formatMessage({ id: 'merchant-integrations.order-api.webhook.url-req' }))
      .test(
        'startsWithHttps',
        intl.formatMessage({ id: 'merchant-integrations.order-api.webhook.url-https' }),
        (input: string) => input != null && input.startsWith('https://'),
      ),
  });
